module.exports = __webpack_public_path__ + "static/media/loader.641a359c.gif";